/**
 * Which view the Consent Form tab in Study Design shows.
 *
 * - builder: a consent form record exists
 * - create_button: the protocol is analysed but no consent form record exists
 *   (offer to create it, rather than a dead end)
 * - loading: the analysis or the artifact list has not been read yet, so
 *   nothing is claimed either way
 * - upload_protocol: nothing has been analysed yet
 */
export type ConsentTabState = 'builder' | 'create_button' | 'upload_protocol' | 'loading';

export function consentTabState(
  hasAnalysis: boolean,
  hasConsentArtifact: boolean,
  ready: boolean = true,
): ConsentTabState {
  if (hasConsentArtifact) return 'builder';
  if (!ready) return 'loading';
  return hasAnalysis ? 'create_button' : 'upload_protocol';
}
